// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const UserAvatar = require('client-v2/common/components/user-avatar')
// Container imports
const ArticleProfileCommentsItem = require('./comments-item')

const MAX_COMMENT_LENGTH = 10000

const bem = BemEntity('ArticleProfileComments')

class ArticleProfileComments extends React.PureComponent {
  constructor(props) {
    super(props)

    this.formInputRef = React.createRef()
    this.onFormSubmit = this.onFormSubmit.bind(this)
  }

  onFormSubmit(event) {
    event.preventDefault()
    const { article, isLoading, user } = this.props
    if (isLoading) {
      return // Prevent submissions while loading
    }
    const formInput = this.formInputRef.current
    const commentText = formInput.value
    formInput.value = ''
    this.props.onFormSubmit({ article, commentText, user })
  }

  renderForm() {
    const { isLoading, user } = this.props
    if (!user.loggedIn) {
      return null
    }
    const placeholder = isLoading
    ? 'Fetching comments...'
    : 'Add a public comment...'
    return (
      tag('form', {
        className: bem.element('form'),
        onSubmit: this.onFormSubmit
      },
        tag(UserAvatar, {
          className: bem.element('form-icon'),
          user: user,
          visible: true
        }),
        tag('input', {
          ref: this.formInputRef,
          className: bem.element('form-input'),
          disabled: isLoading,
          maxLength: MAX_COMMENT_LENGTH,
          placeholder
        }),
        tag('button', {
          className: bem.element('form-button'),
          disabled: isLoading
        },
          'Post'
        )
      )
    )
  }

  renderList() {
    const { article, items, user } = this.props
    if (!items || !items.length) {
      return null
    }
    return (
      tag('ul', {
        className: bem.element('list')
      },
        items.map(comment => (
          tag(ArticleProfileCommentsItem, {
            key: `comments-item:${comment.id}`,
            className: bem.element('list-item'),
            // Values
            article,
            comment,
            user,
            // Callbacks
            onDeleteClick: this.props.onItemDelete,
            onReportClick: this.props.onItemReport,
            onUserClick: this.props.onItemUserClick
          })
        ))
      )
    )
  }

  render() {
    return (
      tag('section', {
        className: classNames(
          this.props.className,
          bem.block()
        )
      },
        this.renderList(),
        this.renderForm()
      )
    )
  }
}

ArticleProfileComments.propTypes = {
  // Flags
  isLoading: PropTypes.bool,
  // Values
  article: PropTypes.object.isRequired,
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
  user: PropTypes.object.isRequired,
  // Callbacks
  onFormSubmit: PropTypes.func,
  onItemDelete: PropTypes.func,
  onItemReport: PropTypes.func,
  onItemUserClick: PropTypes.func
}

module.exports = ArticleProfileComments
